export default __webpack_public_path__ + "images/favicon-32x32.png?413c04234738b0d3735f891d3e322c68";